module.exports = __webpack_public_path__ + "media/newstyle/images/ar_on_you-40265de07d8dda48e9aa402fbc8554e6.png";